import {
  isActiveFormStatus,
  isCompletedFormStatus,
  normalizeFormStatus,
} from "./formTabs";

export const getCampaignForms = (campaignOrForms) => {
  if (Array.isArray(campaignOrForms)) {
    return campaignOrForms;
  }

  return Array.isArray(campaignOrForms?.forms) ? campaignOrForms.forms : [];
};

/**
 * Campaign status follows its surveys:
 * active if any survey is active, complete if every survey is complete,
 * otherwise draft (or not_active when the remaining surveys were ended).
 */
export const getCampaignStatusFromForms = (campaignOrForms) => {
  const forms = getCampaignForms(campaignOrForms);

  if (forms.length === 0) {
    return "draft";
  }

  if (forms.some((form) => isActiveFormStatus(form?.status))) {
    return "active";
  }

  if (forms.every((form) => isCompletedFormStatus(form?.status))) {
    return "complete";
  }

  if (forms.some((form) => normalizeFormStatus(form?.status) === "draft")) {
    return "draft";
  }

  return "not_active";
};

export const withDerivedCampaignStatus = (campaign) => {
  if (!campaign || typeof campaign !== "object") {
    return campaign;
  }

  return {
    ...campaign,
    status: getCampaignStatusFromForms(campaign),
  };
};

export const withDerivedCampaignStatuses = (campaigns) =>
  (Array.isArray(campaigns) ? campaigns : []).map(withDerivedCampaignStatus);

export const getCampaignSortTime = (campaign) => {
  const raw =
    campaign?.created_at ||
    campaign?.createdAt ||
    campaign?.updated_at ||
    campaign?.updatedAt;

  const parsed = new Date(raw).getTime();
  return Number.isNaN(parsed) ? 0 : parsed;
};
